import { motion } from 'framer-motion';
import { Cpu, Rocket, TrendingUp, Coins, Timer } from 'lucide-react';

const CAMPUSES = [
  { icon: Rocket, title: 'AI STARTUP', sub: 'Build AI-native businesses that print.', text: 'Build AI-powered products, agencies and tools. Use playbooks from operators who have already shipped and scaled. AI is the biggest wealth transfer in a generation — be on the winning side.' },
  { icon: Coins, title: 'MEMECOIN', sub: 'Alpha before the crowd.', text: 'Entries, exits, and risk frameworks for the most volatile market on earth. Learn how to navigate noise, identify real narratives, and size positions you can survive.' },
  { icon: TrendingUp, title: 'STOCK TRADING', sub: 'Compound capital intelligently.', text: 'Technical analysis, risk management, and portfolio construction. Swing and positional strategies from operators who actually trade.' },
  { icon: Cpu, title: 'FOREX TRADING', sub: 'The world’s deepest market.', text: 'Majors, gold, session playbooks, and live daily breakdowns in Bangla, Hindi & English. Signals with clear entries, stops, and targets.' },
  { icon: Timer, title: 'FIXED TIME TRADING', sub: 'Rules + risk = edge.', text: 'Most people treat fixed-time like a casino. Inside AlveeTrade, you get rules, risk frameworks, and execution discipline — so it becomes a skill, not a gamble.' },
];

export default function Campuses() {
  return (
    <section className="section-pad bg-[hsl(240_6%_7%)] border-t border-b border-border">
      <div className="container-x">
        <div className="mb-5 max-w-3xl">
          <div className="text-[11px] uppercase tracking-[0.22em] text-[hsl(43_92%_56%)] mb-2">The Latest Information</div>
          <h2 className="font-display uppercase text-3xl sm:text-4xl lg:text-5xl leading-[0.95]">WHAT YOU'LL LEARN</h2>
          <p className="text-muted-foreground mt-3 text-sm">Fresh signals & breakdowns delivered every day. Be first to act on every revolution.</p>
        </div>
        <div className="grid gap-3 sm:gap-4 md:grid-cols-2 lg:grid-cols-3">
          {CAMPUSES.map((c, i) => (
            <motion.div
              key={c.title}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.4, delay: i * 0.03 }}
              className="group relative rounded-2xl card-surface overflow-hidden hover:border-[rgba(245,185,66,0.45)] transition-colors"
            >
              <div className="absolute inset-x-0 top-0 h-[2px]" style={{ background: 'linear-gradient(90deg, transparent, rgba(245,185,66,0.65), transparent)' }} />
              <div className="p-4 sm:p-5 space-y-2">
                <div className="flex items-center gap-2.5">
                  <div className="h-9 w-9 rounded-lg flex items-center justify-center bg-[rgba(245,185,66,0.08)] text-[hsl(43_92%_56%)] border border-[rgba(245,185,66,0.28)] group-hover:bg-[rgba(245,185,66,0.14)] transition-colors">
                    <c.icon className="h-4 w-4" />
                  </div>
                  <div>
                    <div className="font-display uppercase text-base tracking-wide leading-tight">{c.title}</div>
                    <div className="text-[10px] text-[hsl(43_92%_56%)] mt-0.5 uppercase tracking-wider">{c.sub}</div>
                  </div>
                </div>
                <p className="text-[13px] text-[hsl(0_0%_82%)] leading-snug line-clamp-3">{c.text}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
